
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.56.44A1.5 1.5 0 10.44 2.56L3.878 6 .439 9.44a1.5 1.5 0 002.122 2.12L6 8.122l3.44 3.44a1.5 1.5 0 002.12-2.122L8.122 6l3.44-3.44A1.5 1.5 0 009.439.44L6 3.878 2.56.439z"}})])
          )
        }
      }
    